<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0 p-5" style="    margin: 1vw .9vw;">
        <h3>تدوین ارکان جهت ساز
        </h3>
        <hr class="mb-3">
        <div class="d-flex flex-nowrap">
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center ">
            <h3>نمای کلی سازمان</h3>
            <router-link to="/Vision_working_group_Questions" class="btn btn-submit-1 btn-primary"
                         style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی
            </router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="first_check">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>مولفه های ارکان جهت ساز</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType" class="btn btn-submit-1 btn-primary"
                         style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی
            </router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="third_check">🟢</span><span v-else>🔴</span></p>
          </div>


          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3> تصویر سازی آینده</h3>
            <router-link to="/Vision_working_group_future" class="btn btn-submit-1 btn-primary"
                         style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی
            </router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="fourth_check">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3> ارکان جهت ساز پیشنهادی</h3>
            <router-link to="/Vision_working_group_Suggested_perspective" class="btn btn-submit-1 btn-primary"
                         style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی
            </router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="second_check">🟢</span><span v-else>🔴</span></p>
          </div>


        </div>
        <div class="d-flex flex-nowrap mt-2">

          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>تدوین ارزش های سازمانی</h3>
            <router-link to="/Vision_working_group_Suggested_perspective" class="btn btn-submit-1 btn-primary"
                         style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی
            </router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="second_check">🟢</span><span v-else>🔴</span></p>
          </div>
        </div>
        <hr class="mt-2">

        <div class="d-flex flex-row mt-2 ">
          <small class=""><span>تکمیل شده  :</span><span>🟢</span></small>

          <small class=""><span>تکمیل نشده  :</span> <span>🔴</span></small>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data() {
    return {
      first_check: false,
      second_check: false,
      third_check: false,
      fourth_check: false,
    }
  },
  methods: {
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }

    },
    all() {
      fetch(`${this.base_url}/VisionQuestion/check`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({}),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.first_check) {
              this.first_check = response.first_check
              this.second_check = response.second_check
              this.third_check = response.all_hamel_questionnaire_true
              this.fourth_check = response.all_team_vision_true
            }


          }).catch((err) => {
      })
    },
  },
  mounted() {
    this.checkIsMother()
    this.all()
  }
}
</script>
<style scoped lang="scss">
a {
  font-size: 1vw;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/

h3 {
  font-size: 1.3vw !important;
}

small, span {
  font-size: 1vw !important;
}
</style>